/**
 * Alfül-váltó egy képernyőn belül. (2.0)
 *
 * Az 1.0-ban a Törzsadatoknak két alfüle volt, és a váltó bele volt drótozva.
 * A 2.0-ban több képernyő is alfülekre bomlik (Partnerek, Sofőrök és autók),
 * ezért ez egy közös, újrahasznosítható darab lett.
 */
export function AlfulValto<T extends string>({
  ertek,
  fulek,
  onValt,
}: {
  ertek: T;
  fulek: Array<{ kulcs: T; cimke: string; kesz?: boolean; cim?: string }>;
  onValt: (kulcs: T) => void;
}) {
  return (
    <div className="vsw">
      {fulek.map((f) => (
        <button
          key={f.kulcs}
          className={ertek === f.kulcs ? 'on' : ''}
          disabled={f.kesz === false}
          title={f.cim}
          onClick={() => onValt(f.kulcs)}
        >
          {f.cimke}
        </button>
      ))}
    </div>
  );
}
